export const locale = {
    lang: 'en',
    data: {
        LANDING_SECTION: {
            LAST_VIEWED: {
                TITLE: 'Recently Viewed',
            },
            APPOINTMENTS: {
                TITLE: 'Upcoming Appointments',
                BUTTON_TEXT: 'View All Appointments',
            },
            MESSAGES: {
                TITLE: 'Unread Messages',
                BUTTON_TEXT: 'View All Messages',
            },
            OPEN_HOUSES: {
                TITLE: 'Open Houses',
                BUTTON_TEXT: 'View All Open Houses',
            },
            VIEW_ALL: 'View All'
        }
    }
};